import React from 'react';
import OnboardingForm from './OnboardingForm';

const OnboardingWrapper: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800">
      {/* Onboarding Form */}
      <div className="pt-8">
        <OnboardingForm />
      </div>
    </div>
  );
};

export default OnboardingWrapper;